export const NOT_INTERESTED_REASONS = [
  {key: 1, label: 'Job role'},
  {key: 2, label: 'Salary'},
  {key: 3, label: 'Location'},
  {key: 4, label: 'Experience'},
] as const;

export type NotInterestedReason =
  (typeof NOT_INTERESTED_REASONS)[number]['key'];

export const NOT_INTERESTED_ACTION_SRC = {
  notInterested: 'Not Interested',
  undo: 'Undo',
  feedbackSubmit: 'FeedbackSubmit',
} as const;

export type NotInterestedActionSrc =
  (typeof NOT_INTERESTED_ACTION_SRC)[keyof typeof NOT_INTERESTED_ACTION_SRC];
